<template>
  <div class="layout-navbar-fixed">
    <nav
      class="main-header navbar navbar-expand bg-light layout-navbar-fixed"
      :class="{ 'ml-0': share }"
    >
      <div class="w-100">
        <b-row
          class="main-header1"
          style="align-items: center"
        >
          <b-col>
            <template v-if="!($route.meta.do_not_show && $route.meta.do_not_show == true)">
              <PageHeaderTitle />
            </template>
          </b-col>
          <div class="float-right mr-2">
            <MainHeaderShared v-if="share" />
            <MainHeaderConnected
              v-else
              @refresh="doRefresh"
              @show-help="showHelp"
            />
          </div>
        </b-row>
        <b-row
          v-if="show_sub_menu"
          align-v="end"
          class="main-header2"
        >
          <MainHeaderSubMenu
            :routes="routes"
            @refresh="doRefresh"
            @show-modal="showModal"
          />
        </b-row>
      </div>
    </nav>

    <Wiki
      v-if="!share"
      ref="edit_form"
      :current_obj_="current_page"
      current_operation="view"
      :has-child="true"
      :history="doc_navigation"
      :is-documentation="is_documentation"
      :modal_id="modal_id"
      :size="size_wiki"
      @cancelled=";(current_page = null), (doc_navigation = [])"
      @childNav="childNavigation"
      @previousPage="goPreviousPage"
    />

    <AcisoTree
      v-if="!share"
      ref="aciso_tree"
      modal_id="aciso_tree"
    />
    <ReviewsModal
      v-if="!share"
      ref="modal_review"
    />
  </div>
</template>

<script>
import Wiki from '@/contexts/documentation/wiki/Wiki.vue'
import PageHeaderTitle from '@/components/layout/PageHeaderTitle.vue'
import AcisoTree from '@/components/ui/AcisoTree.vue'
import ReviewsModal from '@/contexts/reviews/ReviewsModal.vue'
import MainHeaderSubMenu from '@/components/layout/main-header/MainHeaderSubMenu.vue'
import MainHeaderShared from '@/components/layout/main-header/shared/MainHeaderShared.vue'
import MainHeaderConnected from '@/components/layout/main-header/connected/MainHeaderConnected.vue'
import { rootBus } from '@/contexts/shared/event-bus/RootBus'
import { nextTick } from 'vue'
import { useReactiveSet } from '@/composables/UseReactiveSet.composables'

export default {
  name: 'MainHeader',
  components: {
    ReviewsModal,
    Wiki,
    AcisoTree,
    PageHeaderTitle,
    MainHeaderSubMenu,
    MainHeaderShared,
    MainHeaderConnected,
  },
  props: {
    share: {
      type: Boolean,
      default: false,
    },
    customer: {
      type: String,
      default: '',
    },
  },
  data: function () {
    return {
      isChildren: false,
      tree: {},
      size_wiki: 'lg',
      is_documentation: true,
      current_page: null,
      current_rating: null,
      modal_id: 'help',
      identifier: null,
      api_endpoint: 'wiki',
      doc_navigation: [],
      loading_values: false,
      finish_loading: false,
    }
  },
  computed: {
    show_sub_menu() {
      let max_depth = 4
      if (this.$route.matched.length > 0 && this.$route.matched[0].path == '/nav') {
        max_depth = 5
      }
      return this.routes && this.routes.length > 0 && this.$route.matched.length < max_depth
    },
    routes() {
      const parent_multi = this.$route.matched.find((route) => route.meta.multi === true)
      if (parent_multi != null) {
        return this.$router
          .getRoutes()
          .filter(
            (route) =>
              route.parent &&
              route.parent.name === parent_multi.name &&
              (route.meta.is_authorized(route) ||
                (route.meta.is_optional === true &&
                  route.meta.is_authorized(route) &&
                  route.name !== 'risk-analysis')) &&
              route.parent.meta.multi
          )
      }
      return null
    },
  },
  watch: {
    $route() {
      this.$log.debug(this.$route)
      if (this.$refs.edit_form) {
        this.$refs.edit_form.hide()
      }
      if (this.$os_body) {
        this.$os_body.scroll({ y: 0 }, 1000)
      }
    },
    show_sub_menu() {
      nextTick(() => {
        $('body').Layout('fixLayoutHeight')
      })
    },
  },
  beforeDestroy() {
    rootBus.off('treeViz', this.onTreeViz)
    rootBus.off('modalReview', this.onModalReview)
  },
  mounted: function () {
    this.$log.debug(this.$route)
    rootBus.on('treeViz', this.onTreeViz)
    rootBus.on('modalReview', this.onModalReview)
    this.doc_navigation = []
    const regex_download = new RegExp('^blob:')
    window.addEventListener('click', ($event) => {
      // ensure we use the link, in case the click has been received by a subelement
      let { target } = $event

      while (target && target.tagName !== 'A') {
        target = target.parentNode
      }

      if (target && target.href) {
        if (target.matches("a[data-toggle='tab']")) {
          return
        }
        // handle only links that do not reference external resources
        let url = ''
        try {
          url = new URL(target.href)
        } catch {
          this.$log.debug('ERROROOOO')
          return
        }

        const to = url.pathname
        if (target.matches("a:not([href*='://'])") && target.href && to.startsWith('/doc/')) {
          // some sanity checks taken from vue-router:
          // https://github.com/vuejs/vue-router/blob/dev/src/components/link.js#L106
          const { altKey, ctrlKey, metaKey, shiftKey, button, defaultPrevented } = $event
          // don't handle with control keys
          if (metaKey || altKey || ctrlKey || shiftKey) {
            return
          }
          // don't handle when preventDefault called
          if (defaultPrevented) {
            return
          }
          // don't handle right clicks
          if (button !== undefined && button !== 0) {
            return
          }
          if (target.getAttribute) {
            const linkTarget = target.getAttribute('target')
            if (/\b_blank\b/i.test(linkTarget)) {
              return
            }
          }
          // don't handle same page links/anchors

          event.preventDefault()
          if (window.location.pathname !== to && $event.preventDefault) {
            if (to.includes('/doc/') && !window.location.pathname.startsWith('/doc/')) {
              const doc_identifier = to.substring(5)
              const _this = this
              if (doc_identifier) {
                if (this.current_page) {
                  this.loadPage(doc_identifier)
                } else if (this.current_news) {
                  this.goToChildren(doc_identifier)
                }
              } else {
                _this.$log.debug('No page to load')
              }
            } else {
              this.$log.debug('GO TO', to)
              this.$router.push(to)
            }
          }
        } else if (target.matches("a[href*='://']") && url.href && !url.href.match(regex_download)) {
          event.preventDefault()
          window.open(url, '_blank')
        }
      }
    })
  },
  methods: {
    onTreeViz(tree) {
      this.$log.debug('EEE', tree)
      this.tree = tree
      nextTick(() => {
        if (this.$refs.aciso_tree && this.tree) {
          this.$refs.aciso_tree.show(tree)
        }
      })
    },
    onModalReview: function (e) {
      this.$log.debug('ModalReview', e)
      nextTick(() => {
        if (this.$refs.modal_review) {
          this.$refs.modal_review.showReview(e)
        }
      })
    },
    doRefresh(event, route) {
      const routeToGo = this.$router.resolve(route)
      const route_name = routeToGo.route.name

      if (route_name === 'risk-analysis') {
        this.$store.commit('set_return_recap_from_header', true)
      } else {
        this.$store.commit('set_return_recap_from_header', false)
      }
      if (event.ctrlKey === true) {
        // if click + ctrl
        window.open(routeToGo.href, '_blank')
        return false
      } else if (route_name === this.$route.name) {
        // Force refresh
        rootBus.emit('l2nav', routeToGo.route)
      } else {
        this.$router.push(routeToGo.route).catch((err) => {
          this.$log.error(err)
        })
      }
    },
    childNavigation(current_page) {
      const child_identifier = current_page.identifier
      if (child_identifier) {
        this.loadPage(child_identifier)
      }
    },
    goPreviousPage() {
      if (this.doc_navigation && this.doc_navigation.length > 1) {
        this.doc_navigation.pop()
        const new_identifier = this.doc_navigation[this.doc_navigation.length - 1]
        this.loadPage(new_identifier, true)
      }
    },
    showHelp() {
      const _this = this
      this.size_wiki = 'lg'
      this.is_documentation = true
      if (this.$route.meta.doc_id) {
        this.identifier = this.$route.meta.doc_id
        this.loadPage(this.identifier)
      } else {
        _this.loadDocumentation()
      }
    },
    loadDocumentation() {
      this.current_page = {}
    },
    loadPage(identifier, back = false) {
      const _this = this
      this.$http
        .get(this.api_endpoint + '/page/' + identifier)
        .then((resp) => {
          if (resp.data.ok) {
            this.current_page = resp.data.object
            useReactiveSet(this.current_page, 'current_rating', resp.data.rating)
            this.$log.debug('CURRENT PAGE', this.current_page)
            if (!back) {
              this.doc_navigation.push(identifier)
            }
          } else {
            throw new Error()
          }
        })
        .catch((e) => {
          _this.doc_navigation.push('no-page')
          _this.loadDocumentation()
          _this.$log.debug(e)
        })
    },
    goToChildren(identifier, back = false) {
      const _this = this
      this.finish_loading = false
      setTimeout(() => {
        if (this.finish_loading === false) {
          _this.loading_values = true
        }
      }, 500)
      this.$http
        .get(this.api_endpoint + '/page/' + identifier)
        .then((resp) => {
          if (resp.data.ok) {
            this.finish_loading = true
            this.loading_values = false
            this.current_rating = resp.data.rating
            this.isChildren = true
            _this.$store.dispatch('updateNbReviews')
            if (!back) {
              this.doc_navigation.push(identifier)
            }
          } else {
            throw new Error()
          }
        })
        .catch((e) => {
          this.loading_values = false
          this.finish_loading = true
          _this.$log.debug(e)
        })
    },
    showModal() {
      this.$bvModal.show('analysis_disabled')
    },
  },
}
</script>

<style lang="scss" scoped>
.bg-light {
  background-color: var(neutral-50);
}

.main-header {
  border: none !important;
  padding-bottom: 0px;
}

.main-header1 {
  height: 60px !important;
  border: none !important;
}

.main-header2 {
  height: 40px !important;
  border: none !important;
}

.breadcrumb {
  font-weight: 400 !important;
  font-size: 20px !important;
  line-height: 22px !important;
  padding: 0 !important;
  margin-top: 20px !important;
  margin-left: 25px !important;
  margin-bottom: 20px !important;
}

@media (max-width: 1600px) {
  .main-header {
    margin-left: 70px !important;
  }
}
</style>
